import { c as _c } from "react/compiler-runtime";
import { StyledCard } from '../../common/base/Card';
import Text from '../../common/base/Text';
import { default as FullscreenLayout } from '../../layouts/FullscreenLayout';
import OnboardingNav from './Onboarding/OnboardingNav';
import TeamSelection from './Nav/TeamSelection/TeamSelection';
import Container from '../../common/base/Container';
const TeamSelect = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <OnboardingNav />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Text bold={true} size="2xl" m={{
      b: 1
    }}>Select a project</Text>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text muted={true} size="m" m={{
      b: 8
    }}>Choose a project to work within, or create a new project or organization.</Text>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      width: "fit-content",
      margin: "0 auto"
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <FullscreenLayout center={true}>{t0}<Container medium={true}>{t1}{t2}<StyledCard overflow_hidden={true} style={t3}><TeamSelection h={{
            px: 284
          }} /></StyledCard></Container></FullscreenLayout>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default TeamSelect;